<template>
  <div>
    <van-row class="contentStyle ">
      <van-col
        span="2"
        style="line-height: 30px"
        @click="$router.push({ name: 'ChannelMembers', params: { account: groupNo } })"
      >
        <van-icon
          name="arrow-left"
          style="padding-top: 5px"
          color="#ffffff"
          size="27px"
        />
      </van-col>
      <van-col span="20" style="text-align: left">
        <div id="searchBar">
          <van-field
            v-model="search"
            style="
              padding: 0px 10px;
              line-height: 30px;
              height: 30px;
              background-color: #ffffff;
              color: #646566;
              border: 1px solid #ffffff;
              border-radius: 6px;
            "
          />
        </div>
      </van-col>
      <van-col span="2"> </van-col>
    </van-row>
    <van-list v-model="isLoading" @load="query_members" :finished="finished" finished-text="没有更多了" >
      <div>
        <van-row v-for="(item, index) in memberList" :key="index" class="rowDesign"
            @click="$router.push({ name: 'ChannelMemberDetails', params: { userId: item.account, chennelId:groupNo } })">
                <van-col span="6" style="text-align: center;" class="channelUserStyle">
                    <img :src="item.avatar" class="imageStyle" />
                </van-col>
                <van-col span="18" style="text-align: left;">
                    <van-row class="channelUserRowStyle">
                    <span v-if="item.name">{{item.name}}</span>
                    <span v-else>{{item.account}}</span>
                    </van-row>
                </van-col>
        </van-row>
    </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: "ChannelMemberSearch",
  data() {
    return {
      search: "",
      query:"",
      memberList:[],
      groupNo:"",
      isLoading:false,
      finished:false,
      page:0,
      awaitingSearch: false,
    };
  },
  watch: {
    search: function (val) {
      this.page = 0;
      this.query = val;
      if (!this.awaitingSearch) {
          setTimeout(() => {
            this.query_members(val,this.page)
            this.awaitingSearch = false;
          }, 1000);
        }
        this.awaitingSearch = true;
      
      this.memberList  = [];
      this.finished = true;
    },
  },
  methods: {
      
    query_members(query,pageNo) { 
      let that = this; 
      let page;
      if(!pageNo){
          page = that.page;
      }else{
          page = pageNo;
      }
      that
      .$wonderChat({
          url: "api/group/member/list/"+that.groupNo+"/"+page,
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {
            keyword:that.query
          },
        })
        .then((res) => {
          let resData = res.data; 
          that.isLoading = false;
              if (resData.code == 200) {
                that.page = page + 1;
                that.memberList = that.memberList.concat(resData.dataList); 
                if (resData.dataList.length < 20){
                   that.finished = true;
                }
              } else {
                that.$toast.fail(resData.msg);
              }
        });
      
    },
    isLogin() {
      if (!this.$store.state.loginType) {
        this.$router.push("/login");
      }
    },
  },
  mounted: function () {
    this.isLogin();
    this.groupNo = this.$route.params.chennelNo;
  },
};
</script>

<style scoped>
.contentStyle {
  background-color: #ee0a24;
}

#searchBar {
  padding-top: 6px;
}

.channelUserStyle {
  text-align: left;
  padding-right: 10px;
}

.imageStyle {
  width: 40px;
  border-radius: 25px;
}

.channelUserRowStyle {
  padding-top: 12px;
  color: #000000;
}

.rowDesign {
  padding: 4px 10px;
  border-bottom: 1px solid #dcdee0;
}
</style>

<style>
#searchBar .van-field__control {
  color: #646566 !important;
  font-size: 14px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ChannelMemberSearch.vue